import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { Loader2 } from 'lucide-react';
// TODO: Replace EmailJS service_id, template_id, and public_key with your actual Doctor Ecommerce EmailJS credentials
const EMAILJS_SERVICE_ID = 'service_doctorecommerce';
const EMAILJS_TEMPLATE_ID = 'template_restaurant';
const EMAILJS_PUBLIC_KEY = 'YOUR_PUBLIC_KEY';
const CALENDAR_URL = 'https://calendar.app.google/PYPdcRoYne7QrNJA7';
export function ContactForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');
    try {
      // If keys are placeholders, simulate success for demo purposes
      if (EMAILJS_PUBLIC_KEY === 'YOUR_PUBLIC_KEY') {
        await new Promise(resolve => setTimeout(resolve, 1500));
        setSubmitStatus('success');
        (e.target as HTMLFormElement).reset();
        setIsSubmitting(false);
        return;
      }
      await emailjs.sendForm(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, e.currentTarget, EMAILJS_PUBLIC_KEY);
      setSubmitStatus('success');
      (e.target as HTMLFormElement).reset();
    } catch (error) {
      console.error('EmailJS Error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section id="contacto" className="py-20 md:py-32 px-4 bg-[#0a0a0a] border-b border-gray-900 scroll-mt-20" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-5xl font-bold text-gold mb-4" data-id="element-4">
            Solicita Tu Diagnóstico Gratuito
          </h2>
          <p className="text-lg text-gray-400" data-id="element-5">
            Completa el formulario y un especialista en marketing para
            restaurantes te contactará en menos de 24 horas.
          </p>
        </div>

        <div className="bg-gray-900/30 border border-gray-800 p-6 md:p-10 rounded-lg shadow-2xl" data-id="element-6">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-7">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-8">
              <div className="space-y-2" data-id="element-9">
                <label htmlFor="nombre" className="block text-sm font-medium text-gray-300" data-id="element-10">
                  Nombre completo *
                </label>
                <input required type="text" name="nombre" id="nombre" className="w-full bg-gray-900 border border-gray-700 text-white placeholder-gray-500 focus:border-gold focus:ring-1 focus:ring-gold rounded-sm px-4 py-3 min-h-[48px] outline-none transition-colors" data-id="element-11" />
              </div>
              <div className="space-y-2" data-id="element-12">
                <label htmlFor="email" className="block text-sm font-medium text-gray-300" data-id="element-13">
                  Email *
                </label>
                <input required type="email" name="email" id="email" className="w-full bg-gray-900 border border-gray-700 text-white placeholder-gray-500 focus:border-gold focus:ring-1 focus:ring-gold rounded-sm px-4 py-3 min-h-[48px] outline-none transition-colors" data-id="element-14" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-15">
              <div className="space-y-2" data-id="element-16">
                <label htmlFor="telefono" className="block text-sm font-medium text-gray-300" data-id="element-17">
                  Número de teléfono *
                </label>
                <input required type="tel" name="telefono" id="telefono" className="w-full bg-gray-900 border border-gray-700 text-white placeholder-gray-500 focus:border-gold focus:ring-1 focus:ring-gold rounded-sm px-4 py-3 min-h-[48px] outline-none transition-colors" data-id="element-18" />
              </div>
              <div className="space-y-2" data-id="element-19">
                <label htmlFor="restaurante" className="block text-sm font-medium text-gray-300" data-id="element-20">
                  Nombre del restaurante *
                </label>
                <input required type="text" name="restaurante" id="restaurante" className="w-full bg-gray-900 border border-gray-700 text-white placeholder-gray-500 focus:border-gold focus:ring-1 focus:ring-gold rounded-sm px-4 py-3 min-h-[48px] outline-none transition-colors" data-id="element-21" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-22">
              <div className="space-y-2" data-id="element-23">
                <label htmlFor="instagram" className="block text-sm font-medium text-gray-300" data-id="element-24">
                  Instagram del restaurante
                </label>
                <input type="text" name="instagram" id="instagram" placeholder="@turestaurante" className="w-full bg-gray-900 border border-gray-700 text-white placeholder-gray-500 focus:border-gold focus:ring-1 focus:ring-gold rounded-sm px-4 py-3 min-h-[48px] outline-none transition-colors" data-id="element-25" />
              </div>
              <div className="space-y-2" data-id="element-26">
                <label htmlFor="website" className="block text-sm font-medium text-gray-300" data-id="element-27">
                  Website
                </label>
                <input type="text" name="website" id="website" placeholder="www.turestaurante.com" className="w-full bg-gray-900 border border-gray-700 text-white placeholder-gray-500 focus:border-gold focus:ring-1 focus:ring-gold rounded-sm px-4 py-3 min-h-[48px] outline-none transition-colors" data-id="element-28" />
              </div>
            </div>

            <div className="space-y-2" data-id="element-29">
              <label htmlFor="clientes_actuales" className="block text-sm font-medium text-gray-300" data-id="element-30">
                ¿Cuántos clientes recibes por semana actualmente?
              </label>
              <select name="clientes_actuales" id="clientes_actuales" className="w-full bg-gray-900 border border-gray-700 text-white focus:border-gold focus:ring-1 focus:ring-gold rounded-sm px-4 py-3 min-h-[48px] outline-none transition-colors appearance-none" data-id="element-31">
                <option value="" data-id="element-32">Selecciona una opción</option>
                <option value="Menos de 100" data-id="element-33">Menos de 100</option>
                <option value="100-300" data-id="element-34">100-300</option>
                <option value="300-500" data-id="element-35">300-500</option>
                <option value="500-1000" data-id="element-36">500-1000</option>
                <option value="Más de 1000" data-id="element-37">Más de 1000</option>
              </select>
            </div>

            <div className="space-y-2" data-id="element-38">
              <label htmlFor="meta_clientes" className="block text-sm font-medium text-gray-300" data-id="element-39">
                ¿Cuál es tu meta semanal de clientes nuevos?
              </label>
              <select name="meta_clientes" id="meta_clientes" className="w-full bg-gray-900 border border-gray-700 text-white focus:border-gold focus:ring-1 focus:ring-gold rounded-sm px-4 py-3 min-h-[48px] outline-none transition-colors appearance-none" data-id="element-40">
                <option value="" data-id="element-41">Selecciona una opción</option>
                <option value="50-100" data-id="element-42">50-100</option>
                <option value="100-200" data-id="element-43">100-200</option>
                <option value="200-500" data-id="element-44">200-500</option>
                <option value="500+" data-id="element-45">500+</option>
              </select>
            </div>

            <div className="space-y-2" data-id="element-46">
              <label htmlFor="experiencia_ads" className="block text-sm font-medium text-gray-300" data-id="element-47">
                ¿Has invertido en publicidad digital antes?
              </label>
              <select name="experiencia_ads" id="experiencia_ads" className="w-full bg-gray-900 border border-gray-700 text-white focus:border-gold focus:ring-1 focus:ring-gold rounded-sm px-4 py-3 min-h-[48px] outline-none transition-colors appearance-none" data-id="element-48">
                <option value="" data-id="element-49">Selecciona una opción</option>
                <option value="No nunca" data-id="element-50">No nunca</option>
                <option value="Sí pero sin resultados" data-id="element-51">
                  Sí pero sin resultados
                </option>
                <option value="Sí con algunos resultados" data-id="element-52">
                  Sí con algunos resultados
                </option>
                <option value="Sí con buenos resultados" data-id="element-53">
                  Sí con buenos resultados
                </option>
              </select>
            </div>

            <div className="space-y-2" data-id="element-54">
              <label htmlFor="inversion_previa" className="block text-sm font-medium text-gray-300" data-id="element-55">
                ¿Cuánto has invertido en publicidad en los últimos 12 meses?
              </label>
              <select name="inversion_previa" id="inversion_previa" className="w-full bg-gray-900 border border-gray-700 text-white focus:border-gold focus:ring-1 focus:ring-gold rounded-sm px-4 py-3 min-h-[48px] outline-none transition-colors appearance-none" data-id="element-56">
                <option value="" data-id="element-57">Selecciona una opción</option>
                <option value="Nada" data-id="element-58">Nada</option>
                <option value="Menos de $1,000" data-id="element-59">Menos de $1,000</option>
                <option value="$1,000-$5,000" data-id="element-60">$1,000-$5,000</option>
                <option value="$5,000-$10,000" data-id="element-61">$5,000-$10,000</option>
                <option value="Más de $10,000" data-id="element-62">Más de $10,000</option>
              </select>
            </div>

            <div className="space-y-2" data-id="element-63">
              <label htmlFor="mensaje" className="block text-sm font-medium text-gray-300" data-id="element-64">
                Mensaje adicional (opcional)
              </label>
              <textarea name="mensaje" id="mensaje" rows={4} className="w-full bg-gray-900 border border-gray-700 text-white placeholder-gray-500 focus:border-gold focus:ring-1 focus:ring-gold rounded-sm px-4 py-3 outline-none transition-colors resize-y" data-id="element-65"></textarea>
            </div>

            {submitStatus === 'success' && <div className="p-4 bg-emerald/10 border border-emerald/30 rounded-sm text-emerald text-center font-medium" data-id="element-66">
                ¡Gracias! Tu solicitud ha sido enviada. Te contactaremos en
                menos de 24 horas.
              </div>}

            {submitStatus === 'error' && <div className="p-4 bg-red-500/10 border border-red-500/30 rounded-sm text-red-400 text-center font-medium" data-id="element-67">
                Hubo un error al enviar el formulario. Por favor, intenta de
                nuevo o agenda directamente.
              </div>}

            <button type="submit" disabled={isSubmitting} className="w-full inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-carbon bg-gold hover:bg-[#d9a404] transition-all duration-200 rounded-sm disabled:opacity-70 disabled:cursor-not-allowed hover:scale-[1.02]" data-id="element-68">
              {isSubmitting ? <>
                  <Loader2 className="w-5 h-5 mr-2 animate-spin" data-id="element-69" />
                  ENVIANDO...
                </> : 'ENVIAR SOLICITUD'}
            </button>
          </form>
        </div>

        <div className="mt-8 text-center" data-id="element-70">
          <a href={CALENDAR_URL} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-gold transition-colors inline-flex items-center gap-2" data-id="element-71">
            ¿Prefieres agendar directamente? Reserva tu cita aquí →
          </a>
        </div>
      </div>
    </section>;
}